module.exports = __webpack_public_path__ + "img/tab-quill-hover.c3c8b201.svg";